import React, { FC } from 'react';
import { ApplicationCard } from './ApplicationCard';
import MachinelogicAppIcon from './assets/MachinelogicAppIcon';

interface MachinelogicApplicationCardProps {
    openMachineLogicAppEditor: () => void;
    hasMachinelogicApp: boolean;
  }
export const MachinelogicApplicationCard: FC<MachinelogicApplicationCardProps> = ({ openMachineLogicAppEditor, hasMachinelogicApp }) => {
  return ApplicationCard({
    icon: <MachinelogicAppIcon />,
    title: "Code Free Programming",
    description: "Create and edit a custom application using Vention's code-free visual sequence editor.",
    onClickText: hasMachinelogicApp ? 'See All' : 'Start',
    onClick: openMachineLogicAppEditor
  });
};